import ApiBase from './ApiBase';

export default class CdusService extends ApiBase {
  async fetchCdu(id) {
    const { data } = await this.client.get(`/${id}`);

    return data;
  }
}
